module.exports = __webpack_public_path__ + "img/no_jl.525749c2.png";